import {
  useModalContext,
  WSButton,
  WSButtons,
  WSCheckboxToggle,
  WSElement,
  WSFormOld,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { ErrorContextKey } from "../../../../services/platform";
import { useUserId } from "../../../../query/hooks/helpers";
import { useUpdateActivity } from "../../../../query/users/mutations";
import * as Yup from "yup";

export const DEBIT_CARD_TC_MODAL = "DEBIT_CARD_TC_MODAL";

export const DebitCardTCModal: React.FC = () => {
  const { closeModal } = useModalContext();

  const memberId = useUserId();
  const [updateActivity, updateActivityMeta] = useUpdateActivity(memberId);

  const onClose = () => closeModal(DEBIT_CARD_TC_MODAL);

  return (
    <WSModal name={DEBIT_CARD_TC_MODAL} size="S" onClose={onClose}>
      {({ callback }) => (
        <WSElement p="S">
          <WSText.Heading4 mb="XL">
            Create a new Visa debit card
          </WSText.Heading4>

          <WSText mt="M" mb="2XL">
            In order to continue, you must also agree to the{" "}
            <a
              href="https://www.wingspan.app/banking-disclosures/wingspan-business-visa-debit-cardholder-agreement"
              target="_blank"
              rel="noreferrer"
            >
              Wingspan Business VISA Debit Cardholder Agreement
            </a>{" "}
            that allow us to create this card on your behalf.
          </WSText>
          <WSText mt="M" mb="2XL">
            The Wingspan Visa® Debit Card is issued by Lead Bank, N.A., Member
            FDIC. pursuant to a license from Visa U.S.A. Inc. and may be used
            everywhere Visa debit cards are accepted.
          </WSText>

          <WSFormOld
            mt="2XL"
            defaultValues={{
              isAccepted: false
            }}
            validationSchema={Yup.object().shape({
              isAccepted: Yup.boolean().oneOf([true], "Please accept")
            })}
            onSubmit={async () => {
              await updateActivity({
                events: {
                  debitCardTCAcceptedAt: new Date()
                }
              });
              onClose();
              callback();
            }}
          >
            <WSFormOld.Field
              name="isAccepted"
              component={WSCheckboxToggle}
              componentProps={{
                label: (
                  <>
                    I agree to the{" "}
                    <a
                      href="https://www.wingspan.app/banking-disclosures/wingspan-business-visa-debit-cardholder-agreement"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Wingspan Business VISA Debit Cardholder Agreement.
                    </a>
                  </>
                )
              }}
            />

            <WSErrorMessage
              mt="2XL"
              contextKey={ErrorContextKey.Other}
              error={updateActivityMeta.error}
            />

            <WSButtons forceFullWidth mt="2XL">
              <WSFormOld.Value name="isAccepted">
                {isAccepted => (
                  <WSFormOld.SubmitButton
                    data-testid="submitCreateCard"
                    disabled={!isAccepted}
                    fullWidth
                  >
                    Create card
                  </WSFormOld.SubmitButton>
                )}
              </WSFormOld.Value>

              <WSButton.Secondary onClick={onClose}>Cancel</WSButton.Secondary>
            </WSButtons>
          </WSFormOld>
        </WSElement>
      )}
    </WSModal>
  );
};
